import React from 'react';

const LocationImg = 'https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/LocationBlue2.svg';
const CarImg = 'https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/car-front-blue.svg';

import { TypeCard } from '../../../../../../components/TypeCard';

import { typeLocationSchedule } from '../../../../../../models/Schedule';

const HomeImg = 'https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/HomeBlue.svg';
const CameraImg =
  'https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/TelemedicineCamera.svg';
import { Container } from './styles';
import { CoverageProps } from '../../../../../../models/Product';

type CoverageSelectorProps = {
  coverages?: CoverageProps[];
  selectedCoverage?: CoverageProps;
  handleSelectCoverage: (coverage: CoverageProps) => void;
  productName?: string;
};

const CARE_TYPES: { [x: string]: any } = {
  PRESENTIAL: 'Presencial',
  EINSTEIN_TO_YOU: 'Einstein até você',
  TELEMEDICINE: 'Telemedicina',
  DRIVE_THRU: 'Drive-thru',
  PROCEDURE: 'PROCEDURE'
};

export const CoverageSelector = ({
  coverages,
  selectedCoverage,
  handleSelectCoverage,
  productName
}: CoverageSelectorProps) => {
  const vaccineCoveragesIndex = (coverage: CoverageProps): number => {
    switch (coverage.care_type) {
      case typeLocationSchedule.PRESENTIAL:
        return 1;
      case typeLocationSchedule.DRIVE_THRU:
        return 2;
      case typeLocationSchedule.EINSTEIN_TO_YOU:
        return 3;
      case typeLocationSchedule.TELEMEDICINE:
        return 4;
      default:
        return 10;
    }
  };

  const renderSubtitle = (coverage: CoverageProps): string | undefined => {
    if (!productName?.toUpperCase().includes('DIU'))
      switch (coverage.care_type) {
        case typeLocationSchedule.PRESENTIAL:
          return 'Escolha uma unidade';
        case typeLocationSchedule.DRIVE_THRU:
          return 'Direto no seu carro';
        case typeLocationSchedule.EINSTEIN_TO_YOU:
          return 'Atendimento domiciliar';
        case typeLocationSchedule.TELEMEDICINE:
          return 'Consulta virtual';
        default:
          return undefined;
      }
  };

  const renderIcon = (coverage: CoverageProps): string | undefined => {
    if (!productName?.toUpperCase().includes('DIU'))
      switch (coverage.care_type) {
        case typeLocationSchedule.PRESENTIAL:
          return LocationImg;
        case typeLocationSchedule.DRIVE_THRU:
          return CarImg;
        case typeLocationSchedule.EINSTEIN_TO_YOU:
          return HomeImg;
        case typeLocationSchedule.TELEMEDICINE:
          return CameraImg;
        default:
          return undefined;
      }
  };

  const renderTileName = (itemAlias: string, careType: string) => {
    if (careType === 'PROCEDURE') return itemAlias;
    if (productName?.toUpperCase().includes('DIU')) return itemAlias;
    return CARE_TYPES[careType];
  };

  const coveragesToShow = coverages?.map(c => c);
  if (coveragesToShow) {
    coveragesToShow.sort((coverageA, coverageB) => vaccineCoveragesIndex(coverageA) - vaccineCoveragesIndex(coverageB));
  }

  React.useEffect(() => {
    if (coverages?.length === 1) {
      handleSelectCoverage(coverages[0]);
    }
  }, [coverages]);

  return (
    <Container>
      <>
        {coveragesToShow?.map(coverage => (
          <TypeCard
            key={coverage.id}
            checked={!!selectedCoverage && selectedCoverage.id === coverage.id}
            onClick={() => handleSelectCoverage(coverage)}
            title={renderTileName(coverage.item_alias, coverage.care_type)}
            description={renderSubtitle(coverage)}
            iconSrc={renderIcon(coverage)}
          />
        ))}
      </>
    </Container>
  );
};
